import React from "react";

import { EmployeeInfo } from "../../components/EmployeeInfo/EmployeeInfo";
import {Header} from "../../components/Header/Header"


export const Profile: React.FC = () => {

    return (

        <div className="profile-page">
            <Header />
            <EmployeeInfo 
                signup={false}
             />
        </div>
    );
};

require('./styles.scss')
